import React, { Suspense, useEffect, useState } from 'react';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import { useShallowSelector } from 'lib/util';
import HttpApi from 'i18next-http-backend';
import i18n from 'i18next';

export default function TranslationsProvider({ children }) {
  const { language } = useShallowSelector(state => ({
    language: state.app.language,
  }));
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initI18n = async () => {
      if (i18n.isInitialized) {
        setIsInitialized(true);
        return;
      }
      try {
        await i18n
          .use(HttpApi)
          .use(initReactI18next)
          .init({
            debug: true,
            lng: language.toLowerCase(),
            fallbackLng: language.toLowerCase(),
            // supportedLngs는 백엔드에서 제공하는 언어로 자동 설정됨
            backend: {
              // loadPath: (lngs, _namespaces) => {
              //   return `${process.env.REACT_APP_PUBLIC_S3_URL}/dof/lang/auth/translation.{{lng}}.json`;
              // },
              loadPath: `${process.env.REACT_APP_PUBLIC_S3_URL}/dof/lang/auth/translation.{{lng}}.json`,
              crossDomain: true,
              requestOptions: {
                cache: 'no-cache',
              },
            },
            keySeparator: false,
            interpolation: {
              escapeValue: false,
            },
            react: {
              useSuspense: true,
            },
          });

        console.log('I18N] HTTP Backend를 통한 i18n 초기화 완료');
        setIsInitialized(true);
      } catch (error) {
        console.error('I18N] HTTP Backend i18n 초기화 중 오류 발생: ', error);
      }
    };

    initI18n();
  }, [language]);

  useEffect(() => {
    if (isInitialized && language) {
      // 현재 언어와 같으면 변경하지 않음
      if (i18n.language.toLowerCase() === language.toLowerCase()) {
        return;
      }
      i18n.changeLanguage(language.toLowerCase());
    }
  }, [language, isInitialized]);

  return (
    <Suspense fallback={null}>
      <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
    </Suspense>
  );
}
